import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../../../../utils/api-client';
import {useDocumentTagsQueryCache} from './use-document-tags-query';
import {useAvailableTagsQueryCache} from './use-available-tags-query';
import {showErrorNotification} from '../../../../../providers/notifications-center/show-notification';

interface Params {
    accession: string;
    tag: string;
    isPrivate: boolean;
}

function addDocTagRequest({accession, isPrivate, tag}: Params) {
    return apiClient.post({
        path: `editor-documents-service/api/documents/${accession}/tags`,
        query: {'is-private-tags': isPrivate},
        parameters: [tag]
    });
}

export function useAddTagMutation() {
    const documentTagsQueryCache = useDocumentTagsQueryCache();
    const availableTagsQueryCache = useAvailableTagsQueryCache();

    return useMutation({
        mutationFn: addDocTagRequest,
        onMutate: (params: Params) => {
            documentTagsQueryCache.addTag(params.accession, params.tag, params.isPrivate);
            availableTagsQueryCache.invalidate();
        },
        onError: (error, params) => {
            showErrorNotification()(error);
            documentTagsQueryCache.removeTag(params.accession, params.tag, params.isPrivate);
        }
    });
}
